import React from 'react';
import { string } from 'prop-types';
import styles from './Title.scss';

export default function Title({ children }) {
  return (
    <h2 className={styles.main}>
      {children}
    </h2>
  );
}

Title.propTypes = {
  children: string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/MapPanel/Title/index.js